import { useState } from 'react';
import styled from 'styled-components';

var ServiceChip = styled.button`
  padding: 0.25rem 0.6rem;
  border-radius: 20px;
  border: 1.5px solid ${function (p) {
      return p.$active ? '#000' : '#ccc';
    }};
  background: ${function (p) {
    return p.$active ? '#000' : '#fff';
  }};
  color: ${function (p) {
    return p.$active ? '#fff' : '#333';
  }};
  font-size: 0.7rem;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: #000;
  }
`;

var ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  justify-content: center;
  margin-bottom: 0.25rem;
`;

var OtherInput = styled.input`
  padding: 0.25rem 0.6rem;
  border-radius: 20px;
  border: 1.5px solid #ccc;
  font-size: 0.7rem;
  outline: none;
  width: 120px;

  &:focus {
    border-color: #000;
  }
`;

var STREAMING_SERVICES = [
  { key: 'amazon_music', label: 'Amazon Music' },
  { key: 'apple_music', label: 'Apple Music' },
  { key: 'bandcamp', label: 'Bandcamp' },
  { key: 'cassette', label: 'Cassette' },
  { key: 'cd', label: 'CD' },
  { key: 'deezer', label: 'Deezer' },
  { key: 'pandora', label: 'Pandora' },
  { key: 'qobuz', label: 'Qobuz' },
  { key: 'soundcloud', label: 'SoundCloud' },
  { key: 'spotify', label: 'Spotify' },
  { key: 'tidal', label: 'Tidal' },
  { key: 'vinyl', label: 'Vinyl' },
  { key: 'youtube_music', label: 'YouTube Music' },
];

// Props:
//   selected: string[]        — currently selected service keys
//   onChange: (string[]) => void — called with updated selection
//   otherValue: string        — current "other" text
//   onOtherChange: (string) => void — called when "other" text changes
function StreamingServicesPicker(props) {
  var selected = props.selected || [];
  var onChange = props.onChange;
  var otherValue = props.otherValue || '';
  var onOtherChange = props.onOtherChange;

  function toggle(key) {
    if (selected.indexOf(key) >= 0) {
      onChange(
        selected.filter(function (s) {
          return s !== key;
        })
      );
    } else {
      onChange(selected.concat(key));
    }
  }

  return (
    <div style={{ width: '100%' }}>
      <ChipRow>
        {STREAMING_SERVICES.map(function (svc) {
          return (
            <ServiceChip
              key={svc.key}
              type="button"
              $active={selected.indexOf(svc.key) >= 0}
              onClick={function () {
                toggle(svc.key);
              }}
            >
              {svc.label}
            </ServiceChip>
          );
        })}
        <OtherInput
          type="text"
          placeholder="Other..."
          value={otherValue}
          onChange={function (e) {
            onOtherChange(e.target.value.slice(0, 50));
          }}
        />
      </ChipRow>
      <p style={{ textAlign: 'center', color: '#aaa', fontSize: '0.65rem', margin: '0.4rem 0 0' }}>
        We use this info to tailor your experience on HeavyRotation. We will never sell your data to
        a third party.
      </p>
    </div>
  );
}

export default StreamingServicesPicker;
export { STREAMING_SERVICES };
